import { createAction } from 'redux-actions';
import { ExchangeSegmentsState } from '../types';

export const SET_SEGMENTS = 'EXCHANGE/SET_SEGMENTS';
export const TOGGLE_SEGMENT = 'EXCHANGE/TOGGLE_SEGMENT';
export const TOGGLE_ALL_SEGMENTS = 'EXCHANGE/TOGGLE_ALL_SEGMENTS';
export const SET_SEGMENT_DATE = 'EXCHANGE/SET_SEGMENT_DATE';
export const CLEAR_SEGMENTS_DATE = 'EXCHANGE/CLEAR_SEGMENTS_DATE';

export interface SetSegmentSelectPayload {
	id: string;
	selected: boolean;
}

export interface SelectSegmentDatePayload {
	id: string;
	date: Date | undefined;
}

export const setSegments = createAction<ExchangeSegmentsState>(SET_SEGMENTS);

export type SetSegmentsAction = ReturnType<typeof setSegments>;

export const setAllSegmentsSelect = createAction<boolean>(TOGGLE_ALL_SEGMENTS);

export type ToggleAllSegmentsAction = ReturnType<typeof setAllSegmentsSelect>;

export const setSegmentSelect = createAction<SetSegmentSelectPayload>(TOGGLE_SEGMENT);

export type ToggleSegmentAction = ReturnType<typeof setSegmentSelect>;

export const setSegmentDate = createAction<SelectSegmentDatePayload>(SET_SEGMENT_DATE);

export type SetSegmentDateAction = ReturnType<typeof setSegmentDate>;

export const clearSegmentsDate = createAction(CLEAR_SEGMENTS_DATE);

export type ClearSegmentsDateAction = ReturnType<typeof clearSegmentsDate>;
